import { render } from "./MessageAuthorAvatar.vue.js?vue&type=template&id=a27a5b54&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageAuthorAvatar.vue?vue&type=template&id=a27a5b54&scoped=true"
import script from "./MessageAuthorAvatar.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageAuthorAvatar.vue?vue&type=script&lang=js"
export * from "./MessageAuthorAvatar.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageAuthorAvatar.vue?vue&type=script&lang=js"

import "./MessageAuthorAvatar.vue.scss?vue&type=style&index=0&id=a27a5b54&lang=scss&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageAuthorAvatar.vue?vue&type=style&index=0&id=a27a5b54&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27a5b54"],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/MessageAuthorAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a27a5b54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a27a5b54', __exports__)) {
    api.reload('a27a5b54', __exports__)
  }
  
  module.hot.accept("./MessageAuthorAvatar.vue.js?vue&type=template&id=a27a5b54&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageAuthorAvatar.vue?vue&type=template&id=a27a5b54&scoped=true", () => {
    api.rerender('a27a5b54', render)
  })

}


export default __exports__